import api from '../baseApi.js'
import { unwrap } from '../helpers.js'

export const dashboardApi = {
  getStudentCount: () =>
    api.get('/users', { params: { role: 'student', limit: 1000 } }).then(unwrap),

  getTeacherCount: () =>
    api.get('/users', { params: { role: 'teacher', limit: 1000 } }).then(unwrap),

  getClassCount: () =>
    api.get('/classes').then(unwrap),

  getFeeSummary: () =>
    api.get('/fees/summary').then(unwrap),

  getParentCount: () =>
    api.get('/users', { params: { role: 'parent', limit: 1000 } }).then(unwrap),

  getActivity: () =>
    api.get('/notifications', { params: { limit: 5 } }).then(unwrap),
}
